import { z } from 'zod';
import { defineCollection, type RecordOf } from '../collection.ts';
import { id, requiredText } from '../fields.ts';

/** Collections that can carry a small comment thread. */
export const COMMENTABLE = ['events', 'tasks', 'albums', 'photos', 'memories', 'notices', 'documents', 'pets'] as const;

/**
 * Contextual comments. A comment is visible to exactly the people who can see
 * the item it is attached to; anyone who can see the item may comment.
 */
export const comments = defineCollection({
  name: 'comments',
  module: 'comments',
  label: { one: 'comment', other: 'comments' },
  schema: z.object({
    targetCollection: z.enum(COMMENTABLE),
    targetId: id,
    body: requiredText(2_000),
  }),
  parent: { kind: 'dynamic', collectionField: 'targetCollection', idField: 'targetId', allowed: COMMENTABLE },
  defaultAudience: 'family',
  childAccess: 'contribute',
  editPolicy: 'author',
  immutableFields: ['targetCollection', 'targetId'],
  manualMergeFields: [],
  canCreate: () => true,
});

export type Comment = RecordOf<typeof comments>;
